import { render, staticRenderFns } from "./VideoTan.vue?vue&type=template&id=6381cdcd&scoped=true"
import script from "./VideoTan.vue?vue&type=script&lang=js"
export * from "./VideoTan.vue?vue&type=script&lang=js"
import style0 from "./VideoTan.vue?vue&type=style&index=0&id=6381cdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6381cdcd",
  null
  
)

export default component.exports